import { Button } from "@mantine/core";

interface PaginationProps {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  onPageChange: (nextPage: number) => void;
}

const Pagination = ({
  pageNumber,
  pageSize,
  totalCount,
  onPageChange,
}: PaginationProps) => {
  if (totalCount <= pageSize) {
    return null;
  }

  const hasPreviousPage = pageNumber > 0;
  const hasNextPage = (pageNumber + 1) * pageSize < totalCount;

  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div>
        {hasPreviousPage && (
          <Button onClick={() => onPageChange(pageNumber - 1)}>
            Previous page
          </Button>
        )}
      </div>
      <div style={{ marginTop: "1rem" }}>Page {pageNumber + 1}</div>
      <div>
        {hasNextPage && (
          <Button onClick={() => onPageChange(pageNumber + 1)}>
            Next page
          </Button>
        )}
      </div>
    </div>
  );
};

export default Pagination;
